import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group'
import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

type ToggleGroupItemProps = React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Item> & {
  value: string
}

export const ToggleGroupItem = forwardRef<
  React.ElementRef<typeof ToggleGroupPrimitive.Item>,
  ToggleGroupItemProps
>(({ className, children, ...props }, ref) => (
  <ToggleGroupPrimitive.Item
    ref={ref}
    className={cn(
      'inline-flex items-center justify-center px-3 py-2 text-xs font-normal transition-colors',
      'disabled:pointer-events-none disabled:opacity-50',
      'data-[state=on]:bg-gray-2 data-[state=on]:text-gray-12',
      ' data-[state=off]:text-gray-8 data-[state=off]:hover:bg-gray-2',
      className,
    )}
    {...props}
  >
    {children}
  </ToggleGroupPrimitive.Item>
))

ToggleGroupItem.displayName = 'ToggleGroupItem'
